<template>
  <div>
    <v-alert v-if="success" border="bottom" color="success" dark>
      {{ successMensaje }}
    </v-alert>
    <v-alert v-if="editado" border="bottom" color="success" dark>
      {{ successMensaje }}
    </v-alert>
    <v-alert v-if="error" border="bottom" color="red" dark>
      <b>Ocurrió un error al guardar el usuario.</b> {{ errorMensaje }}
    </v-alert>
    <v-form v-model="valid" ref="form">
      <v-row>
        <label>&nbsp;Tipo de usuario:</label>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-autocomplete
            v-model="rol_id"
            :items="roles"
            filled
            required
            label="Rol"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="9"></v-col>
      </v-row>

      <div v-show="rol_id === 3">
        <v-row>
          <v-col cols="3">
            <input
              type="radio"
              id="personaFisica"
              value="1"
              v-model="tipoCliente"
            />
            <label for="personaFisica">&nbsp;Persona f&iacute;sica</label>
          </v-col>
          <v-col cols="3">
            <input type="radio" id="empresa" value="0" v-model="tipoCliente" />
            <label for="empresa">&nbsp;Empresa</label>
          </v-col>
        </v-row>

        <!-- Campos específicos para Persona Física -->
        <div v-if="tipoCliente === '1'">
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="Nombre"
                :rules="nombreRules"
                v-model="nombre"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Apellido"
                :rules="apellidoRules"
                v-model="apellido"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Número de CUIT"
                v-model="cuit"
                :rules="cuitRules"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3" v-if="editar">
              <v-chip
                v-if="emailStatus === 'confirmed'"
                color="success"
                outlined
                class="mt-4"
                style="width: 100%;"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Email Confirmado
              </v-chip>
              <v-btn
                v-else
                color="orange"
                small
                outlined
                block
                :loading="confirmandoEmail"
                @click="confirmarEmailAdmin"
                class="mt-4"
              >
                <v-icon left small>mdi-email-check</v-icon>
                Confirmar Email
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- Campos específicos para Empresa -->
        <div v-if="tipoCliente === '0'">
          <v-row>
            <v-col cols="3">
              <v-text-field
                label="Razón social"
                :rules="razonSocialRules"
                v-model="razonSocial"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                label="Número de CUIT"
                v-model="cuit"
                :rules="cuitRules"
                v-on:keyup.enter="register"
              >
              </v-text-field>
            </v-col>
            <v-col cols="3" v-if="editar">
              <v-chip
                v-if="emailStatus === 'confirmed'"
                color="success"
                outlined
                class="mt-4"
                style="width: 100%;"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Email Confirmado
              </v-chip>
              <v-btn
                v-else
                color="orange"
                small
                outlined
                block
                :loading="confirmandoEmail"
                @click="confirmarEmailAdmin"
                class="mt-4"
              >
                <v-icon left small>mdi-email-check</v-icon>
                Confirmar Email
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!-- <v-col cols="3">
          <v-select
            :items="sectorProductivos"
            label="Sector Productivo"
            v-model="sectorProductivo"
          >
          </v-select>
        </v-col> -->
      </div>
      <!-- Otros campos comunes -->
      <v-row>
        <v-col cols="3">
          <v-text-field
            label="Usuario:"
            v-model="usuario"
            :rules="usuarioRules"
            filled
            autocomplete="false"
            v-on:keyup.enter="register"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Celular de contacto"
            :rules="telefonoRules"
            v-model="telefono"
            filled
            autocomplete="false"
            v-on:keyup.enter="register"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Dirección de e-mail"
            :rules="emailRules"
            v-model="email"
            filled
            autocomplete="false"
            v-on:keyup.enter="register"
          >
          </v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            label="Contraseña"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            :rules="confirmPasswordRules"
            v-model="password"
            filled
            autocomplete="new-password"
            v-on:keyup.enter="register"
            name="password"
            required
            counter
            @click:append="show = !show"
          >
          </v-text-field>
        </v-col>
        <!-- <v-col cols="3">
          <div v-show="rol_id === '3'">
            <v-autocomplete
              v-model="sectorProductivo"
              :items="sectorProductivos"
              required
              label="Sector productivo"
            >
            </v-autocomplete>
          </div>
        </v-col> -->
        <v-col cols="3"></v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-btn
            v-if="!editar"
            color="primary"
            x-large
            :loading="loading"
            @click="guardar"
          >
            Guardar
          </v-btn>
          <v-btn
            v-if="editar"
            color="primary"
            x-large
            :loading="loading"
            @click="modificar"
          >
            Editar
          </v-btn>
        </v-col>
        <v-col md="2">
          <v-btn color="success" x-large @click="listado">Ver Listado </v-btn>
        </v-col>
       
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { API_URL } from '@/common/config';

import axios from 'axios';
import { split } from 'lodash';

export default {
  data: () => ({
    userExist: false,
    show: false,
    rol_id: '1',
    rol_id_anterior: '1',
    tipoCliente: '1',
    roles: [],
    email: '',
    usuario: '',
    password: '',
    nombre: '',
    apellido: '',
    cuit: '',
    telefono: '',
    razonSocial: '',
    sectorProductivo: '',
    sectorProductivos: [],
    loading: false,
    success: false,
    successMensaje: '',
    error: false,
    errorMensaje: '',
    valid: false,
    editado: false,
    emailStatus: '',
    confirmandoEmail: false,
    telefonoRules: [
      (v) =>
        !v ||
        /^[0-9]{6,}$/.test(v) ||
        'El número de contacto debe tener al menos 6 dígitos numéricos',
    ],
    nombreRules: [(v) => !!v || 'El campo nombre es obligatorio'],
    apellidoRules: [(v) => !!v || 'El campo apellido es obligatorio'],
    razonSocialRules: [(v) => !!v || 'La razón social es obligatoria'],
    usuarioRules: [
      (v) => !!v || 'El usuario es obligatorio',
      (v) =>
        /^[a-zA-Z0-9_]{4,}$/.test(v) ||
        'El usuario debe tener al menos 4 caracteres alfanuméricos',
    ],
    emailRules: [
      (v) => !!v || 'El correo electronico es obligatorio',
      (v) => /.+@.+/.test(v) || 'El correo electronico no es valido',
    ],
    cuitRules: [
      (v) =>
        !v ||
        /^[0-9]{6,}$/.test(v) ||
        'El CUIT debe contener al menos 11 dígitos numéricos',
      (v) => !!v || 'El CUIT es obligatorio',
    ],
  }),

  props: ['editar'],
  computed: {
    confirmPasswordRules() {
      return [
        (v) => !!v || 'Ingresar una clave',
        (v) =>
          (v && v.length >= 8) ||
          'La contraseña debe tener al menos 8 caracteres', // Cambiado a 8 caracteres
        (v) =>
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
            v
          ) ||
          'La contraseña debe incluir al menos una letra minúscula, una mayúscula, un dígito y un carácter especial (@$!%*?&)',
      ];
    },
  },
  watch: {
    // Observar cambios en nombre, apellido o razón social
    nombre() {
      this.generarUsername();
    },
    apellido() {
      this.generarUsername();
    },
    razonSocial() {
      this.generarUsername();
    },
    cuit() {
      this.generarUsername();
    },
    email() {
      if (this.rol_id !== '3') {
        this.generarUsername();
      }
    },
    // rol_id(newValue) {
    //   if (newValue !== this.rol_id_anterior) {
    //     this.usuario = '';
    //     this.email = '';
    //     this.password = '';
    //     this.rol_id_anterior = newValue; // Actualizar el valor anterior
    //   }
    //    },
    // tipoCliente(nuevoValor) {
    //   if (nuevoValor === '0') {
    //     // Limpiar campos de empresa
    //     this.razonSocial = '';
    //   } else if (nuevoValor === '1') {
    //     // Limpiar campos de persona física
    //     this.nombre = '';
    //     this.apellido = '';
    //   }
    // },
  },
  methods: {
    async generarUsername() {
      // Verificar si el usuario ya tiene un valor manual
      if (this.usuario.length < 0 || this.userExist) {
        return;
      }

      if (this.rol_id !== '3' && this.email.length > 3) {
        this.usuario = this.email.toLowerCase().split('@')[0];
      }

      // Generar username basado en nombre y apellido
      const numberCuit = this.cuit ? this.cuit.slice(-4) : '';
      if (this.nombre && this.apellido) {
        this.usuario = `${this.nombre[0].toLowerCase()}${this.apellido
          .toLowerCase()
          .replace(/\s+/g, '')}${numberCuit ? numberCuit : ''}`;
      }
      // Si no hay nombre y apellido, usar la razón social
      else if (this.razonSocial) {
        this.usuario = `${this.razonSocial
          .toLowerCase()
          .replace(/[\s.,]/g, '')}${numberCuit ? numberCuit : ''}`;
      }
    },

    async loadSectorProductivos() {
      const url = `${API_URL}api/sectoresProductivos`;
      await axios
        .get(url)
        .then((response) => {
          if (response.data.status === 'success') {
            this.sectorProductivos = response.data.sectoresProductivos.map(
              (f) => ({ value: f.id, text: f.nombre })
            );
          } else {
            console.log('Error al obtener los datos');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    resetForm() {
      this.$refs.form.reset();
      this.tipoCliente = '1';
    },
    listado() {
      this.$router.push(`/listado/${this.$route.params.model}/`);
    },

    async guardar() {
      this.loading = true;
      this.success = false;
      this.error = false;

      //Valida dependiendo del rol
      const validationResult =
        this.rol_id === 3
          ? this.$refs.form.validate()
          : this.validateEssentialFields();

      if (validationResult) {
        try {
          // 1. Obtener el token del almacenamiento local
          const token = localStorage.getItem('token');
          if (!token) {
            this.error = true;
            this.errorMensaje =
              'No se ha encontrado un token de sesión. Por favor, inicia sesión.';
            this.loading = false;
            return;
          }

          // 2. Preparar los datos para la solicitud POST
          const data = {
            email: this.email,
            username: this.usuario,
            telefono: this.telefono,
            password: this.password,
            rol: parseInt(this.rol_id),
          };

          if (this.rol_id === 3) {
            // Datos adicionales para clientes
            data.nombre = this.tipoCliente === '1' ? this.nombre : '';
            data.apellido = this.tipoCliente === '1' ? this.apellido : '';
            data.razonSocial = this.tipoCliente !== '1' ? this.razonSocial : '';
            data.cuit = this.cuit;
            data.sectorProductivo = 5;
            data.tipoCliente = parseInt(this.tipoCliente);
          }

          // 3. Determinar la URL según el rol
          const url =
            this.rol_id === 3
              ? `${API_URL}api/v1/auth/register`
              : `${API_URL}api/v1/auth/`;

          // 4. Realizar la solicitud POST
          const response = await axios.post(url, data, {
            headers: { token },
          });

          // 5. Manejar la respuesta
          if (response.data.status === 'success') {
            this.success = true;
            this.successMensaje = response.data.message;
          } else {
            this.error = true;
            this.errorMensaje =
              response.data.message ||
              'Error desconocido al guardar el usuario.';
          }

          // 6. Resetear el formulario
          this.resetForm();
          this.loading = false;
        } catch (error) {
          // 7. Manejo de errores
          this.loading = false;
          this.error = true;
          const errorMessage = error.response
            ? error.response.data.message || 'Error de red'
            : 'Error desconocido';
          this.errorMensaje = `Error al guardar el usuario: ${errorMessage}`;
          console.error('Error al guardar el usuario:', error);
        }
      } else {
        // 8. Mensaje de error de validación
        this.$swal.fire({
          title: 'Error de Validación',
          text: 'Por favor, corrija los errores en el formulario.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#f32',
        });
        this.loading = false;
      }
    },

    validateEssentialFields() {
      const rules = {
        usuario: this.usuarioRules,
        telefono: this.telefonoRules,
        email: this.emailRules,
        password: this.confirmPasswordRules,
      };

      for (const fieldName in rules) {
        const fieldValue = this[fieldName];
        if (!rules[fieldName].every((rule) => rule(fieldValue))) {
          return false;
        }
      }
      return true;
    },

    async modificar() {
      try {
        this.loading = true;

        const token = localStorage.getItem('token');
        if (!token) {
          return;
        }

        // 2. Preparar los datos para la solicitud PUT
        const userData = {
          email: this.email,
          password: this.password,
          rol_id: this.rol_id,
          username: this.usuario,
          telefono: this.telefono,
        };
        const clientData = {
          nombre: this.tipoCliente === '1' ? this.nombre : '',
          apellido: this.tipoCliente === '1' ? this.apellido : '',

          //// empresa
          razonSocial: this.tipoCliente !== '1' ? this.razonSocial : '',
          cuit: this.cuit,
          tipoCliente: parseInt(this.tipoCliente),
        };

        // 3. Realizar la solicitud PUT para actualizar el usuario
        const responseUser = await axios.put(
          `${API_URL}api/v1/auth/${this.$route.params.id}`,
          userData,
          { headers: { token } }
        );

        // 4. Verificar si la actualización del usuario fue exitosa
        if (responseUser.data.status === 'success') {
          // 5. Actualizar la información del cliente
          const responseClient = await axios.put(
            `${API_URL}api/clientes/${this.$route.params.id}`,
            clientData,
            { headers: { token } }
          );
          if (responseClient.data.status === 'error') {
            this.successMensaje = responseClient.data.message;
            this.error = true;
          }
          // 6. Mostrar el mensaje de éxito
          this.successMensaje = responseClient.data.message;
        }
        // else {
        //   if (responseClient.data.message === 'No posee cliente') {
        //     this.successMensaje = responseClient.data.message;
        //   }
        // }
        // 8. Actualizar el estado de la interfaz
        this.loading = false;
        this.editado = true;
      } catch (error) {
        const { message } = error.response.data;
        // 9. Manejar errores generales
        console.error('Error al modificar el usuario:', message);
        this.loading = false;
        this.error = true;
        this.errorMensaje = `${message}`; // Mostrar un mensaje de error general
      }
    },

    async presentarDatos() {
      await axios
        .get(`${API_URL}api/v1/usuarios/${this.$route.params.id}`, {
          headers: {
            token: localStorage.getItem('token'),
          },
        })
        .then((response) => {
          this.userExist = response.data.user.username !== '' ? true : false;
          const cliente = response.data.user.clientes;
          this.email = response.data.user.email;
          this.password = '';
          this.rol_id = response.data.user.rol_id;
          this.telefono = response.data.user.telefono;
          this.usuario = response.data.user.username;
          this.emailStatus = response.data.user.emailStatus || 'unconfirmed';

          if (cliente) {
            this.tipoCliente = cliente[0].tipoCliente.toString();
            this.sectorProductivo = cliente[0].sectorProductivo;
            if (this.tipoCliente === '1') {
              this.nombre = cliente[0].nombre;
              this.apellido = cliente[0].apellido;
              this.cuit = cliente[0].cuit;
            } else {
              this.razonSocial = cliente[0].razonSocial;
              this.cuit = cliente[0].cuit;
            }
          }
        });
    },
    async confirmarEmailAdmin() {
      try {
        this.confirmandoEmail = true;
        const token = localStorage.getItem('token');
        if (!token) {
          this.error = true;
          this.errorMensaje = 'No se ha encontrado un token de sesión.';
          this.confirmandoEmail = false;
          return;
        }

        const response = await axios.patch(
          `${API_URL}api/v1/usuarios/${this.$route.params.id}/confirmar-email-admin`,
          {},
          { headers: { token } }
        );

        if (response.data.status === 'success') {
          this.emailStatus = 'confirmed';
          this.success = true;
          this.successMensaje = response.data.message;
          setTimeout(() => {
            this.success = false;
          }, 3000);
        }
      } catch (error) {
        this.error = true;
        const errorMessage = error.response
          ? error.response.data.message || 'Error al confirmar el email'
          : 'Error desconocido';
        this.errorMensaje = errorMessage;
        console.error('Error al confirmar email:', error);
      } finally {
        this.confirmandoEmail = false;
      }
    },
    async getRoles() {
      const url = `${API_URL}api/roles`;
      const header = {
        headers: {
          token: localStorage.getItem('token'),
        },
      };
      axios.get(url, header).then((result) => {
        if (result.data.status === 'success') {
          this.roles = result.data.roles.map((r) => ({
            value: r.id,
            text: r.nombre,
          }));
        }
      });
    },
  },
  created() {
    this.loadSectorProductivos();
    this.getRoles();
    if (this.editar) {
      this.presentarDatos();
    }
  },
};
</script>
